export enum OperationAction {
  Cancel,
  Retry,
  Locate,
}
